const Chalkboard = ({ children }) => {
  return <div className="chalkboard">{children}</div>
}

export default Chalkboard
